import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ApproachSection from './components/ApproachSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <ServicesSection />
        <ApproachSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
